import { render, staticRenderFns } from "./menu_interface_management.vue?vue&type=template&id=c5a1a536&scoped=true"
import script from "./menu_interface_management.vue?vue&type=script&lang=js"
export * from "./menu_interface_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a1a536",
  null
  
)

export default component.exports